import React, { PropsWithChildren } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { i18n_article_no_risk_cancel_anytime } from '@yi/i18n/phrases/i18n_article_no_risk_cancel_anytime';
import { i18n_trial_for_new_users_only } from '@yi/i18n/phrases/i18n_trial_for_new_users_only';

import { ButtonLocalizedLink } from '../../../buttons';
import { useLocale } from '../../../LocaleProvider';

interface Props {
  heading: React.ReactNode;
  subHeading: string;
  textAboveButton?: string;
  buttonText: string;
  buttonUrl: string;
  buttonLoading?: boolean;
  buttonDisabled?: boolean;
  buttonDataCampaign: string;
  testId: string;
  renderImage?: () => React.ReactNode;
}

const defaultRenderImage = () => (
  <StaticImage
    src={'../../../../images/dashboard-devices.png'}
    placeholder="blurred"
    alt="devices"
    loading="eager"
    style={{ maxWidth: '75%', height: 'auto' }}
    objectPosition="75% 0%"
  />
);

export const PaywallContentWithImage: React.FC<PropsWithChildren<Props>> = ({
  heading,
  subHeading,
  textAboveButton = '',
  buttonText,
  buttonUrl,
  buttonDataCampaign,
  testId,
  renderImage = defaultRenderImage,
  buttonDisabled = false,
  buttonLoading = false,
}) => {
  const { locale } = useLocale();
  return (
    <div className="modal-basic-sign-up-form" data-testid={testId}>
      <div style={{ padding: 15 }}>
        <p
          style={{
            textAlign: 'center',
            marginBottom: 5,
            fontWeight: 700,
            fontSize: 22,
            lineHeight: 'inherit',
          }}
        >
          {heading}
        </p>
        <p
          style={{
            textAlign: 'center',
            marginBottom: 20,
            fontWeight: 'normal',
            fontSize: 17,
            lineHeight: 'inherit',
          }}
        >
          {subHeading}
        </p>
        {renderImage()}
        <p style={{ fontWeight: 'bold', marginBottom: 5, marginTop: 20 }}>{textAboveButton}</p>
        <ButtonLocalizedLink
          to={buttonUrl}
          className="internal-promotion"
          data-campaign={buttonDataCampaign}
          style={{ width: '100%' }}
          disabled={buttonDisabled}
          showSpinner={buttonLoading}
        >
          {buttonText}
        </ButtonLocalizedLink>
        <br />
        <p
          id="myModalClassesPaywallSpam"
          style={{
            textAlign: 'center',
            marginBottom: 0,
            marginTop: 10,
            fontWeight: 'normal',
            fontSize: 13,
          }}
        >
          {i18n_article_no_risk_cancel_anytime(locale)}
          <br />
          {i18n_trial_for_new_users_only(locale)}
        </p>
      </div>
    </div>
  );
};
